import usePaymentMethods, {
	type UsePaymentMethodsOptions,
} from './usePaymentMethods';

/**
 * The account's payment methods, less any a payment cannot be taken with. What
 * this dialog means whenever it speaks of a saved payment method - it exists to
 * take a payment, so a method kept on file to settle bills another way is not
 * one of its options.
 */
const usePayablePaymentMethods = (
	options?: Omit<UsePaymentMethodsOptions, 'payableOnly'>,
) => usePaymentMethods({ payableOnly: true, ...options });

export default usePayablePaymentMethods;
